import { FC } from 'react';

import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import AreasCardText from '@src/main/ui/components/common/Dashboard/common/fields/areas/AreasCardText';
import DescriptionCardText from '@src/main/ui/components/common/Dashboard/common/fields/description/DescriptionCardText';
import { HighlighFields } from '@src/main/ui/components/common/Dashboard/common/fields/highlighter/HighlighFields';
import KeyTagsCardText from '@src/main/ui/components/common/Dashboard/common/fields/tags/KeyTagsCardText';
import TagsCardText from '@src/main/ui/components/common/Dashboard/common/fields/tags/TagsCardText';
import styles from './DashboardCardResumeContent.module.scss';

interface DashboardCardResumeContentProps {
  areas: string[];
  keyTags?: string[];
  tags?: string[];
  description?: string;
  highlighFields?: HighlighFields[];
}

const defaultProps = { keyTags: [], tags: [], description: '', highlighFields: undefined };

const DashboardCardResumeContent: FC<DashboardCardResumeContentProps> = ({
  areas,
  keyTags = [],
  tags = [],
  description,
  highlighFields,
}) => (
  <CardContent
    sx={{
      paddingTop: 0,
      flexGrow: 1,
    }}
  >
    <Typography variant="body2" color="text.secondary">
      <span className={styles.dashboardCardResumeContent__subtitle}>
        <AreasCardText areas={areas} highlighFields={highlighFields} />
      </span>
    </Typography>
    <Typography variant="caption" color="iberiaRed.main">
      <span className={styles.dashboardCardResumeContent__subtitle}>
        <KeyTagsCardText keyTags={keyTags} highlighFields={highlighFields} />
      </span>
    </Typography>
    <Typography variant="caption" color="text.secondary">
      <span className={styles.dashboardCardResumeContent__subtitle}>
        <TagsCardText tags={tags} highlighFields={highlighFields} />
      </span>
    </Typography>
    <Typography variant="body2" color="text.secondary">
      <span className={styles.dashboardCardResumeContent__description}>
        <DescriptionCardText description={description} highlighFields={highlighFields} />
      </span>
    </Typography>
  </CardContent>
);

DashboardCardResumeContent.defaultProps = defaultProps;

export default DashboardCardResumeContent;
